// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__3raTw","dontHaveAccount":"styles_dontHaveAccount__3Luyt","signUp":"styles_signUp__21Vof","register":"styles_register__2vdkv"};